import React, { useRef, useEffect } from 'react'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import { validatePassword } from './utils'
import { withTranslation } from 'react-i18next'
import AuthContainer from './AuthContainer'

const RequireNewPassword = (props) => {
	const formApi = useRef(null)
	const { t, authProps } = props

	const getApi = (api) => {
		formApi.current = api
	}

	useEffect(() => {
		if(authProps.error && formApi.current) {
			switch(authProps.error) {
				case 'Network error':
					formApi.current.setError('password', t('auth_screen.error.network'))
					break
				default:
					formApi.current.setError('password', t('auth_screen.error.unknown'))
					break
			}
		}
	}, [authProps.error])

	const change = async ({ password, password2 }) => {
		await authProps.submitForm({
			password,
			confirm_password: password2
		})
	}

	return(
		<AuthContainer getApi={getApi} className={style.form} onSubmit={change}>
			{({ formState: { values, errors } }) => (
				<>
					<p>{t('auth_screen.message.new_pass_required')}</p>
					<Divider height={20}/>
					<Text
						errors={errors}
						errorClass={style.formInputError}
						validate={validatePassword(t)}
						validateOnChange
						type='password'
						field='password'
						placeholder={t('auth_screen.form.new_password')}
						usePlaceholder
					/>
					<Text
						errors={errors}
						errorClass={style.formInputError}
						validate={password2 => password2 !== values.password ? t('auth_screen.error.pass_match') : null}
						validateOnChange
						type='password'
						field='password2'
						placeholder={t('auth_screen.form.repeat_password')}
						usePlaceholder
					/>
					<Divider height={20}/>
					<Button
						status={!values.password && errors.password ? 'inactive' : 'active'}
						text={t('auth_screen.button.save_password')}
						type='submit'
						{...authProps.isPending && { loading: true }}
					/>
					<div className={style.linkButton} onClick={authProps.toSignIn}>{t('auth_screen.button.go_back')}</div>
				</>
			)}
		</AuthContainer>
	)
}

export default withTranslation()(RequireNewPassword)
